import { getTenantPrefix } from "@/utils/tenant";
import { pickSamplesListQueryForRouter } from "@/components/layout/QAQC/Overview/qaqcSamplesListQuery.js";
import {
  mergeOverviewTabIntoQuery,
  overviewTabFromTestRoute,
} from "@/components/layout/QAQC/Overview/qaqcOverviewTab.js";

export function navigateHome(router, route) {
  const urlSegments = window.location.pathname.split("/").filter(Boolean);
  const tenantId = urlSegments.length > 0 ? urlSegments[0] : getTenantPrefix() || "";
  if (!tenantId || !router) return;

  const section = urlSegments[1]?.toLowerCase() || "";
  if (section === "agentic-dashboard") {
    router.push({ name: "AgenticDashboard" });
    return;
  }

  const lastView = localStorage.getItem("activeMenu");
  const isQaqcRoute = section === "qaqc";
  if (isQaqcRoute) {
    const path = `/${tenantId}/qaqc/overview`;
    const onQaqcTest =
      urlSegments[2]?.toLowerCase() === "test" && urlSegments.length >= 5;
    const query = onQaqcTest
      ? mergeOverviewTabIntoQuery(
          pickSamplesListQueryForRouter(route?.query || {}),
          overviewTabFromTestRoute(route)
        )
      : pickSamplesListQueryForRouter(route?.query || {});
    router.push({ path, query });
    return;
  }

  if (lastView && lastView.toLowerCase() === "data management") {
    router.push(`/${tenantId}/data-management`);
  } else if (lastView && lastView.toLowerCase() === "qa/qc") {
    router.push(`/${tenantId}/qaqc`);
  } else if (lastView && lastView === "QA/QC Overview") {
    const query = pickSamplesListQueryForRouter(route?.query || {});
    router.push({ path: `/${tenantId}/qaqc/overview`, query });
  } else if (section === "assets") {
    router.push(`/${tenantId}/assets`);
  } else {
    router.push(`/${tenantId}/data-management`);
  }
}
